module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage"
  }, [_c('a', {
    attrs: {
      "id": "title19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("From Here to Paternity—romances that feature fantastic men who "), _c('em', {
    staticClass: "i"
  }, [_vm._v("eventually")]), _vm._v(" make fabulous fathers. Some seek paternity, some have it thrust upon them. All will make it—whether they like it or not.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MIRANDA LEE")])]), _vm._v(" is Australian, living near Sydney. Born and raised in the bush, she was boarding-school educated and briefly pursued a classical music career before moving to Sydney and embracing the world of computers. Happily married, with three daughters, she began writing when family commitments kept her at home. She likes to create stories that are believable, modern, fast-paced and sexy. Her interests include reading meaty sagas, doing word puzzles, gambling and going to the movies.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Look out for Miranda Lee’s next riveting romance, A HAUNTING OBSESSION (Harlequin Presents #1893), available in July.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c70efdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459268975_ata01.vue
// module id = 63
// module chunks = 0